

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { DatePipe, NgClass } from '@angular/common';
import { SrStatus, SrStatusAr, SrStatusEn } from '../../constants/status.enum';
import { SharedService } from '../../services/shared.service';
import { FormsModule } from '@angular/forms';
import { Utils } from '../../../Utils/utils';
import { TablePagenationComponent } from '../table-pagenation/table-pagenation.component';

@Component({
  standalone: true,
  selector: 'app-table',
  imports: [TranslateModule, ButtonComponent, NgClass, DatePipe, FormsModule, TablePagenationComponent],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent {
  @Input() tableHeadings: string[] = [];
  @Input() dataKeys: string[] = [];
  @Input() listData: any[] = [];
  @Input() showPagination: boolean = false;
  @Input() showActions: boolean = false;
  @Input() showActionEdit: boolean = false;
  @Input() showActionDelete: boolean = false;
  @Input() showActionView: boolean = false;
  @Input() showActionPay: boolean = false;

  @Input() pageSize: any = 10;
  @Input() totalRecords: any = 0;
  @Input() otherAction: boolean = false;
  @Input() otherActionText: string = "";
  @Input() checkbox: boolean = false;
  @Input() showActionMore: boolean = false
  @Input() loader: boolean = false;
  @Input() customClass: string = "";
  @Input() showActionHeading: boolean = true;
  @Input() restrictSelectionByStatus: boolean = true;

  @Output() onEdit = new EventEmitter<any>();
  @Output() onView = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onPageChange = new EventEmitter<number>();
  @Output() onSelectRow = new EventEmitter<any>();
  @Output() otherActionClick = new EventEmitter<any>();
  @Output() onPayClick = new EventEmitter<any>();
  lang: string = "en";
  srStatus = SrStatus;

  constructor(
    private sharedService: SharedService
  ) {
    this.lang = this.sharedService.getCurrentLang();
  }
  currentPage = 1;
  // This method is used to paginated data
  get paginatedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.listData.slice(start, start + this.pageSize);
  }

  // This method is used to total pages
  get totalPages() {
    return Math.ceil(this.totalRecords / this.pageSize);
  }

  // This method is used to go to page using page
  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.onPageChange.emit(this.currentPage);
    }
  }

  // This method is used to return to the previous page
  prevPage() {
    this.goToPage(this.currentPage - 1);
  }

  // This method is used to move to the next page
  nextPage() {
    this.goToPage(this.currentPage + 1);
  }

  // This method is used to edit member using id
  editMember(id: any) {

  }

  formatCellValue(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    const strValue = String(value);
    return strValue.length > 20 ? `${strValue.slice(0, 20)}...` : strValue;
  }

  getCellTitle(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    return String(value);
  }

  selectedIds = new Set<string>();
  private getSelectableRows(): any[] {
    if (!this.restrictSelectionByStatus) {
      return this.listData ?? [];
    }
    return (this.listData ?? []).filter(row => this.isRowSelectable(row));
  }

  private isRowSelectable(row: any): boolean {
    const status = row?.Status;
    if (!status) {
      return false;
    }

    const selectableStatuses = [
      // Payment related statuses
      SrStatusAr.ApprovedAndPaymentAwaited,
      SrStatusEn.ApprovedAndPaymentAwaited,
      this.srStatus.ApprovedAndPaymentAwaited,
      SrStatusAr.AwaitingFinalPayment,
      SrStatusEn.AwaitingFinalPayment,
      this.srStatus.AwaitingFinalPayment,
      // Downloadable certificate statuses
      SrStatusAr.Paid,
      SrStatusEn.Paid,
      this.srStatus.Paid,
      SrStatusAr.Closed,
      SrStatusEn.Closed,
      this.srStatus.Closed,
      SrStatusAr.AwaitingCarnetReturn,
      SrStatusEn.AwaitingCarnetReturn,
      this.srStatus.AwaitingCarnetReturn,
      this.srStatus.PendingNOC,
      this.srStatus.PendingApproval,
      SrStatusAr.PendingNOC,
      SrStatusEn.PendingApproval
    ];

    return selectableStatuses.includes(status);
  }
  // This method is used to all checked
  allChecked(): boolean {
    const selectableRows = this.getSelectableRows();
    return selectableRows.length > 0 &&
      selectableRows.every(row => this.selectedIds.has(row["SR Number"]));
  }
  // This method is used to some checked
  someChecked(): boolean {
    const selectableRows = this.getSelectableRows();
    return selectableRows.some(row => this.selectedIds.has(row["SR Number"])) &&
      !this.allChecked();
  }
  // This method is used to toggle row using row
  toggleRow(row: any): void {
    const rowId = row["SR Number"];
    if (this.selectedIds.has(rowId)) {
      this.selectedIds.delete(rowId);
    } else {
      this.selectedIds.add(rowId);
    }
    this.emitSelectedRows();
  }

  // This method is used to toggle all using event
  toggleAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const selectableRows = this.getSelectableRows();

    if (checked) {
      selectableRows.forEach(row => this.selectedIds.add(row["SR Number"]));
    } else {
      selectableRows.forEach(row => this.selectedIds.delete(row["SR Number"]));
    }

    this.emitSelectedRows();
  }

  // This method is used to emit selected rows
  emitSelectedRows(): void {
    const selectedRows: any = this.listData?.filter(row =>
      this.selectedIds.has(row["SR Number"])
    ) || [];

    this.onSelectRow.emit(selectedRows);
  }
  // This method is used to get status class using status
  getStatusClass(status: string) {
    // <!-- Payment status -->
    if (status == "Pending") {
      let status = "Closed";
      return this.sharedService.getStatusClass(status)
    }
    return this.sharedService.getStatusClass(status)
  }

  selectedColumn: string = '';
  isMobile = false;
  // This method is used to check screen
  checkScreen() {
    this.isMobile = window.innerWidth < 768;
  }
  // This method is used to get key from heading using heading
  getKeyFromHeading(heading: string): string {
    const index = this.tableHeadings.indexOf(heading);
    return this.dataKeys[index];
  }

  // This method is used to check if valid https url using url
  isValidHttpsUrl(url: unknown): url is string {
    return Utils.checkIsValidURL(url);
  }

  // This method is used to open download link using url
  openDownloadLink(url: unknown): void {
    if (!this.isValidHttpsUrl(url)) {
      return;
    }
    window.open(url, '_blank', 'noopener');
  }

  private getFileNameFromUrl(url: string): string {
    try {
      const { pathname } = new URL(url);
      const fileName = pathname.split('/').filter(Boolean).pop();
      return fileName || 'receipt';
    } catch {
      return 'receipt';
    }
  }

  // This method is used to download file using url
  downloadFileFromUrl(url: unknown): void {
    if (!this.isValidHttpsUrl(url)) {
      return;
    }
    const link = document.createElement('a');
    link.href = url;
    link.download = this.getFileNameFromUrl(url);
    link.rel = 'noopener';
    link.target = '_blank';
    link.click();
    link.remove();
  }

  getSRTypeValue(srType: string, srSubType?: string): string {
   return Utils.getSrTypeValue(srType, srSubType);
  }
}
